// store/orders/getters.ts
import { OrdersState } from ".";

const getters = {
  cartItems: (state: OrdersState) => state.cartItems?.items || [],

  cartTotal: (state: OrdersState) => state.total_general || 0,

  cartTotalUSD: (state: OrdersState) => state.total_general_mone || 0,

  cartTotalDesc: (state: OrdersState) => state.total_general_ext || 0,

  cartTotalDescUSD: (state: OrdersState) => state.total_general_mone_ext || 0,

  cartGrandQuantity: (state: OrdersState) => state.total_unidades || 0,

  cartRenglones: (state: OrdersState) => state.total_renglones || 0,

  // Total por marca (BS)
  cartTotalByMarca: (state: OrdersState) => (marca: string) =>
    (state.cartItems?.items || []).filter((item: { marca: string; }) => item.marca === marca)
      .reduce((total: number, item: { precio1: any; quantity: any; }) => total + Number(item.precio1 ?? 0) * Number(item.quantity ?? 0), 0),

  // Total por marca (USD)
  cartTotalUSDByMarca: (state: OrdersState) => (marca: string) =>
    (state.cartItems?.items || []).filter((item: { marca: string; }) => item.marca === marca)
      .reduce((total: number, item: { precio_usd: any; quantity: any; }) => total + Number(item.precio_usd ?? 0) * Number(item.quantity ?? 0), 0),

  // Cantidad total por marca
  cartGrandQuantityByMarca: (state: OrdersState) => (marca: string) =>
    (state.cartItems?.items || []).filter((item: { marca: string; }) => item.marca === marca)
      .reduce((total: number, item: { quantity: any; }) => total + Number(item.quantity ?? 0), 0),

  // Renglones por marca
  cartRenglonesByMarca: (state: OrdersState) => (marca: string) =>
    (state.cartItems?.items || []).filter((item: { marca: string; }) => item.marca === marca).length,
};

export default getters;
